module.exports = __webpack_public_path__ + "img/H1F2.b6f8ff8d.jpg";